import axios from 'axios'

export const getAllCarriers = (params) => {
  return axios.get('carriers', {params: params})
}

export const getCarrier = (id, params) => {
  return axios.get('carriers/' + id, {params: params})
}

export const addCarrier = (data) => {
  return axios.post('carriers', data)
}

export const editCarrier = (id, data) => {
  return axios.put('carriers/' + id, data)
}

export const deleteCarrier = (id) => {
  return axios.delete('carriers/' + id)
}

export const restoreCarrier = (id) => {
  return axios.post('carriers/' + id + '/restore', {})
}



// WEBPACK FOOTER //
// ./src/api/carrier.js